import React, { useEffect } from 'react';
import Styled from './Alfabetizacao360NewDetail.styled';
import DynamicHeader from 'components/dynamic_header/DynamicHeader';
import FirstSession from './components/FirstSession';
import SecoundSession from './components/SecoundSession';
import ThreeSession from './components/ThreeSession';
import FourSession from './components/FourSession';
import FiveSession from './components/FiveSession';
import ContactContainer from 'pages/home/components/contact/ContactContainer';
import Seminario360 from '../alfabetizacao360Detail/subcomponents/Seminario360';

const Alfabetizacao360NewDetail = () => {
    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const gotoSection = (sectionId: string) => {
        const el = document.getElementById(sectionId);

        if (el) {
            el.scrollIntoView({ block: 'nearest' });
        }
    };

    return (
        <Styled.Container>
            <DynamicHeader />
            {/* {Alfabetizacao} */}
            <FirstSession gotoSection={gotoSection} />
            {/* {Evento do seminário} */}
            <Seminario360 />
            {/* {Sobre Curso / Modulos do curso / atividades praticas} */}
            <div id="SecoundSession">
                <SecoundSession />
            </div>
            {/* {Imagem com curbatura para separação de sessão} */}
        
            {/* {Um curso para promover a alfabetizacao} */}
            <ThreeSession />
            {/* {Mateiral acessivel / download} */}
            <FourSession />
            {/* {Outros conteudos da Humane} */}
            <FiveSession />
            <ContactContainer />
        </Styled.Container>
    );
};

export default Alfabetizacao360NewDetail;
